// @flow
import types from './orderConstants';

const INIT_STATE = {
    orders: [],
    order: null,
    orderNotFound: false,
    items: [],
    statusList: [],
    historyList: [],
    statusFilter: [],
    hasNextPage: false,
    totalCount: 0,
    images: [],
    uploadedImageId: null,
    users: [],
    pendingContentIds: [],
    loading: false,
    loading_items: false,
    success: null
};

const toggleContentChecked = (items, contentId) =>
    items.map(item => ({
        ...item,
        contents: item.contents
            ? item.contents.map(content =>
                content.id === contentId ? { ...content, checked: !content.checked } : content)
            : item.contents
    }));

const Order = (state = INIT_STATE, action) => {
    switch (action.type) {
        case types.CLEAR_STATE:
            return {
                ...INIT_STATE
            }

        //Get Orders
        case types.GET_ORDERS:
            return {
                ...state,
                loading: true
            };
        case types.GET_ORDERS_SUCCESS:
            return {
                ...state,
                orders: action.payload.data.items,
                hasNextPage: action.payload.data.hasNextPage,
                totalCount: action.payload.data.totalCount,
                loading: false,
                error: null
            };
        case types.GET_ORDERS_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        //Get Orders

        //Get Orders
        case types.GET_ORDER:
            return {
                ...state,
                orderNotFound: false,
                loading: true
            };
        case types.GET_ORDER_SUCCESS:
            return {
                ...state,
                order: action.payload.data,
                orderNotFound: false,
                loading: state.loading_items ? true : false,
                error: null
            };
        case types.GET_ORDER_FAILED:
            return {
                ...state,
                order: null,
                orderNotFound: true,
                error: action.payload,
                loading: false
            };
        //Get Orders

        //Get Order Items
        case types.GET_ORDER_ITEMS:
            return {
                ...state,
                loading: true,
                loading_items: action.payload.loading_items
            };
        case types.GET_ORDER_ITEMS_SUCCESS:
            return {
                ...state,
                items: action.payload.data.items,
                loading: false,
                loading_items: false,
                error: null
            };
        case types.GET_ORDER_ITEMS_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false,
                loading_items: false
            };
        //Get Order Items

        // Patch order
        case types.PATCH_ORDER:
            return {
                ...state,
                loading: true
            };
        case types.PATCH_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case types.PATCH_ORDER_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        // Patch order

        //patch order content status (optimistic: toggle immediately without the
        //global loader, toggle back if the request fails; pendingContentIds
        //drives the per-checkbox spinner while the request is in flight)
        case types.PATCH_ORDER_CONTENT_STATUS:
            return {
                ...state,
                items: toggleContentChecked(state.items, action.payload.contentId),
                pendingContentIds: [...state.pendingContentIds, action.payload.contentId]
            };
        case types.PATCH_ORDER_CONTENT_STATUS_SUCCESS:
            return {
                ...state,
                pendingContentIds: state.pendingContentIds.filter(id => id !== action.payload.contentId),
                error: null
            };
        case types.PATCH_ORDER_CONTENT_STATUS_FAILED:
            return {
                ...state,
                items: toggleContentChecked(state.items, action.payload.contentId),
                pendingContentIds: state.pendingContentIds.filter(id => id !== action.payload.contentId),
                error: action.payload.error
            };
        //patch order content status

        //put order content 
        case types.PUT_ORDER_CONTENT:
            return {
                ...state,
                loading: true
            };
        case types.PUT_ORDER_CONTENT_SUCCESS:
            return {
                ...state,
                success: "ORDER.CONTENT.CREATED.SUCESS",
                error: null
            };
        case types.PUT_ORDER_CONTENT_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        //put order content 
        //put order content 
        case types.DELETE_ORDER_CONTENT:
            return {
                ...state,
                loading: true
            };
        case types.DELETE_ORDER_CONTENT_SUCCESS:
            return {
                ...state,
                success: "ORDER.CONTENT.DELETED.SUCESS",
                error: null
            };
        case types.DELETE_ORDER_CONTENT_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        //put order content 
        //replace order content 
        case types.REPLACE_ORDER_CONTENT:
            return {
                ...state,
                loading: true
            };
        case types.REPLACE_ORDER_CONTENT_SUCCESS:
            return {
                ...state,
                success: "ORDER.CONTENT.REPLACED.SUCESS",
                error: null
            };
        case types.REPLACE_ORDER_CONTENT_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        //replace order content 
        //post order content 
        case types.POST_ORDER_CONTENT:
            return {
                ...state,
                loading: true
            };
        case types.POST_ORDER_CONTENT_SUCCESS:
            return {
                ...state,
                success: "ORDER.CONTENT.CREATED.SUCESS",
                error: null
            };
        case types.POST_ORDER_CONTENT_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        //post order content 

        case types.GET_STATUS:
            return {
                ...state,
                statusList: action.payload.data && action.payload.data.items,
                error: null
            };

        case types.GET_HISTORY:
            return {
                ...state,
                historyList: action.payload.data,
                error: null
            };

        case types.GET_STATUS_FILTER:
            return {
                ...state,
                statusFilter: action.payload.data,
                error: null
            };

        case types.GET_IMAGES:
            return {
                ...state,
                images: action.payload.data,
                error: null
            };

        //post order status 
        case types.POST_STATUS:
            return {
                ...state,
                success: null,
                loading: true
            };
        case types.POST_STATUS_SUCCESS:
            return {
                ...state,
                success: types.POST_STATUS_SUCCESS,
                error: null
            };
        case types.POST_STATUS_FAILED:
            return {
                ...state,
                success: null,
                error: action.payload,
                loading: false
            };
        //post order status 

        //image
        // Photo uploads report progress on their own tile (ADR-0020): the
        // global loader stays off, as does the hand-over request below.
        case types.POST_IMAGE:
            return {
                ...state,
                success: null,
                uploadedImageId: null,
                loading: false
            };
        case types.POST_HANDOVER:
            return {
                ...state,
                success: null,
                error: null,
                loading: false
            };
        case types.POST_HANDOVER_SUCCESS:
            return {
                ...state,
                success: null,
                error: null,
                loading: false
            };
        case types.POST_HANDOVER_FAILED:
            return {
                ...state,
                error: action.payload,
                success: null,
                loading: false
            };
        case types.POST_IMAGE_SUCCESS:
            return {
                ...state,
                uploadedImageId: action.payload,
                success: types.POST_IMAGE_SUCCESS,
                loading: false,
                error: null
            };
        case types.POST_IMAGE_FAILED:
            return {
                ...state,
                error: action.payload,
                success: null,
                uploadedImageId: null,
                loading: false
            };
        case types.DELETE_IMAGE:
            return {
                ...state,
                success: null,
                loading: true
            };
        case types.DELETE_IMAGE_SUCCESS:
            var list = [...state.images].filter(s => s.id !== action.payload.id);
            return {
                ...state,
                loading: false,
                images: list,
                success: types.DELETE_IMAGE_SUCCESS,
                error: null
            };
        case types.DELETE_IMAGE_FAILED:
            return {
                ...state,
                error: action.payload,
                success: null,
                loading: false
            };
        //image

        //user
        case types.GET_USERS:
            return {
                ...state,
                users: action.payload.isSuccess ? action.payload.data : [],
            };
        //user
        default:
            return state;
    }
};

export default Order;
